<template>
  <div class="container-md float-page comment" id="comment">
    <!-- 頁面內容 -->
    <section class="section-group pt-4">
      <div class="card p-4">
        <h3 class="page-title mb-2">{{$t('common.comment.opinion')}}</h3>
        <div class="clearfix"></div>
        <hr class="divider" />
        <div class="page-content">
          <p class="mb-3">
            {{$t('common.comment.t1')}}
          </p>
          <el-form
            :model="opinionModel"
            :rules="opinionRules"
            ref="opinionModel"
            label-width="100px;"
          >
            <el-form-item :label="$t('common.comment.label')" prop="type">
              <el-select v-model="opinionModel.type" :placeholder="$t('common.comment.labelplaceholder')">
                <el-option
                  :label="$t('common.comment.optionlabel11')"
                  value="會員帳戶相關／無法登入"
                ></el-option>
                <el-option
                  :label="$t('common.comment.optionlabel12')"
                  value="上載時遇上問題"
                ></el-option>
                <el-option
                  :label="$t('common.comment.optionlabel13')"
                  value="儲存空間不足"
                ></el-option>
                <el-option
                  :label="$t('common.comment.optionlabel14')"
                  value="著作權侵權問題"
                ></el-option>
                <el-option
                  :label="$t('common.comment.optionlabel15')"
                  value="欲移除內容（含有您本人肖像，或違規內容舉報）"
                ></el-option>
                <el-option value="提出建議" :label="$t('common.comment.optionlabel16')"></el-option>
                <el-option :label="$t('common.comment.optionlabel17')" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('common.comment.detail')" prop="content">
              <el-input
                v-model="opinionModel.content"
                type="textarea"
                rows="8"
                :placeholder="$t('common.comment.detailplaceholder')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.comment.name')">
              <el-input v-model="opinionModel.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.comment.email')" prop="email">
              <el-input v-model="opinionModel.email"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.comment.response')" prop="response">
              <el-radio v-model="opinionModel.response" label="true"
                >{{$t('common.comment.yes')}}</el-radio
              >
              <el-radio v-model="opinionModel.response" label="false"
                >{{$t('common.comment.no')}}</el-radio
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('opinionModel')"
                class="btn btn-block btn-primary"
                >{{$t('common.comment.submit')}}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </section>
    <!-- ./頁面內容 -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      opinionModel: {
        type: null,
        content: null,
        name: null,
        email: null,
        response: null,
      },
      opinionRules: {
      },
    };
  },
   watch: {
    //监听语言切换
    '$i18n.locale': function () {
     this.setopinionRules();
    },
  },

  created() {
    this.setopinionRules();
    this.$store.dispatch("updateCurrentIndex", 0);
  },
  methods: {
    setopinionRules(){
      const that = this;
      this.opinionRules = {
        email: [{ required: true, message: that.$t('common.comment.opinionRules.email'), trigger: "blur" }],
        content: [
          { required: true, message: that.$t('common.comment.opinionRules.content'), trigger: "blur" },
        ],
        type: [{ required: true, message: that.$t('common.comment.opinionRules.type'), trigger: "change" }],
        response: [
          {
            required: true,
            message: that.$t('common.comment.opinionRules.response'),
            trigger: "change",
          },
        ],
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            opinionType: this.opinionModel.type,
            OpinionContent: this.opinionModel.content,
            name: this.opinionModel.name,
            email: this.opinionModel.email,
            isReply: this.opinionModel.response,
          };
          this.$api.EventApi.sendOpinion(params).then((result) => {
            if (result.data.success) {
              this.$router.push({ name: "commentsucces" });
            } else {
              Message({
                type: "error",
                message: "失敗",
              });
            }
          });
        } else {
          Message({
            type: "error",
            message: "請填寫必填數據",
          });
          return false;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/comment.vue